"use client";

import { useState } from "react";
import IconArrowDown from "@/app/(components)/generics/Icons/IconArrowDown";
import IconArrowUp from "@/app/(components)/generics/Icons/IconArrowUp";
import Popover from "@/app/(components)/generics/Popover/Popover";
import PopoverContent from "@/app/(components)/generics/Popover/PopoverContent";
import PopoverTrigger from "@/app/(components)/generics/Popover/PopoverTrigger";
import { useAuthUser } from "@/app/(components)/specifics/wrappers/AuthProvider/AuthProvider";
import { updateUser } from "@/app/actions/user/update/action";
import { DefaultProps } from "@/app/types/common/DefaultProps";
import {
  DEFAULT_LOCALE,
  INVERTED_Languages_MIN,
  Languages,
  Languages_MIN,
} from "@/app/vars/Languages";
import styles from "./ChangeLanguage.module.css";

const languages = Object.entries(Languages);

type Props = DefaultProps & { light?: boolean; left?: boolean };

export default function ChangeLanguage(props: Props) {
  const user = useAuthUser();

  const { lang } = props.params || {};
  const safeLang = lang || DEFAULT_LOCALE;

  const currentLang: any = safeLang.toUpperCase();

  const [open, setOpen] = useState(false);

  return (
    <div
      className={`${styles.container} ${props.light ? styles.light : ""} ${props.left ? styles.left : ""}`}
    >
      <Popover
        isVisible={open}
        setIsVisible={setOpen}
        openAfterClick={true}
        closeWhenClickOutside={true}
      >
        <PopoverTrigger>
          <button className={styles.trigger}>
            <p className={styles.language}>{currentLang}</p>
            <div className={styles.arrow}>{open ? <IconArrowUp /> : <IconArrowDown />}</div>
          </button>
        </PopoverTrigger>

        <PopoverContent
          position={{
            default: props.left
              ? { top: "calc(100% + 8px)", left: "0px" }
              : { top: "calc(100% + 8px)", right: "0px" },
          }}
        >
          <div className={styles.content}>
            {languages.map(([key, value], index) => (
              <button
                className={`${styles.button} ${
                  key === INVERTED_Languages_MIN[safeLang as keyof typeof INVERTED_Languages_MIN]
                    ? styles.buttonActive
                    : ""
                }`}
                key={`language-${index}`}
                onClick={async () => {
                  // @ts-expect-error
                  const min = Languages_MIN[key].toLowerCase();

                  const pathnameWithoutLang = window.location.pathname
                    .trim()
                    .split("/")
                    .slice(2)
                    .join("/");

                  if (user) {
                    await updateUser({ language: min }, safeLang);
                  }

                  document.cookie = `locale=${min}; path=/; max-age=${
                    60 * 60 * 24 * 365
                  }; secure=${window.location.protocol === "https:"}; samesite=Strict`;

                  window.location.href = `/${min}/${pathnameWithoutLang}`;
                }}
              >
                {value as string}
              </button>
            ))}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
